import { createContext, useRef, useState } from 'react'

import { BottomSheet } from '../components/ui/bottom-sheet'

interface OpenBottomSheetConfig {
  content: React.ReactNode
  duration?: number
}

interface BottomSheetContextType {
  openBottomSheet: (config: OpenBottomSheetConfig) => void
  closeBottomSheet: () => void
}

export const BottomSheetContext = createContext<BottomSheetContextType>({
  openBottomSheet: () => {},
  closeBottomSheet: () => {},
})

export function BottomSheetContextProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [content, setContent] = useState<React.ReactNode | null>(null)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const openBottomSheet = ({ content, duration }: OpenBottomSheetConfig) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setIsOpen(true)
    setContent(content)
    if (duration) {
      timeoutRef.current = setTimeout(() => {
        setIsOpen(false)
        timeoutRef.current = null
      }, duration)
    }
  }

  const closeBottomSheet = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setIsOpen(false)
  }

  return (
    <BottomSheetContext.Provider value={{ openBottomSheet, closeBottomSheet }}>
      <BottomSheet open={isOpen} close={() => setIsOpen(false)}>
        {content}
      </BottomSheet>
      {children}
    </BottomSheetContext.Provider>
  )
}
